export default "__VITE_ASSET__CeofqgAF__"